import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _get from 'lodash/get';
import { EMPTY_OBJECT, EMPTY_STRING } from '../app.constants';
import LS_CACHE_KEYS from '../constants/loginDataLSCacheKeys';
import { removeValueFromLocalStorage, getValueFromLocalStorage, setValueInLocalStorage } from './localStorage';
export var APPLICATION_STORAGE_KEY = 't_application_storage';
export var clearApplicationLocalStorage = function clearApplicationLocalStorage() {
  removeValueFromLocalStorage(APPLICATION_STORAGE_KEY);
};
export var setValueInApplicationLocalStorage = function setValueInApplicationLocalStorage(key, value) {
  var applicationLocalStorage = JSON.parse(getValueFromLocalStorage(APPLICATION_STORAGE_KEY)) || EMPTY_OBJECT;
  setValueInLocalStorage(APPLICATION_STORAGE_KEY, JSON.stringify(_objectSpread(_objectSpread({}, applicationLocalStorage), {}, _defineProperty({}, key, value))));
};
export var getValueFromApplicationLocalStorage = function getValueFromApplicationLocalStorage(key) {
  var applicationLocalStorage = JSON.parse(getValueFromLocalStorage(APPLICATION_STORAGE_KEY)) || EMPTY_OBJECT;
  return _get(applicationLocalStorage, key);
};
export var getApmTokenFromLocalStorage = function getApmTokenFromLocalStorage() {
  var apmToken = EMPTY_STRING;

  try {
    apmToken = getValueFromLocalStorage(LS_CACHE_KEYS.APM_AUH_TOKEN);
  } catch (err) {
    console.error('Apm token not available');
  }

  return apmToken;
};